(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
(function () {
  var MAX_COPIES = 20;

  function layout(bar) {
    var track = bar.querySelector('.marquee__track');
    if (!track) return;

    // Start from a clean single group so repeated calls don't stack clones.
    track.querySelectorAll('.marquee__group--clone').forEach(function (el) {
      el.remove();
    });

    var group = track.querySelector('.marquee__group');
    if (!group) return;

    var styles = getComputedStyle(bar);
    var gap = parseFloat(styles.getPropertyValue('--marquee-gap')) || 0;
    var speed = parseFloat(bar.dataset.speed) || 60;

    var groupWidth = group.getBoundingClientRect().width;
    var barWidth = bar.getBoundingClientRect().width;
    if (!groupWidth || !barWidth) return;

    // Fill at least twice the bar width, so a group is always waiting
    // off-screen to take over when the one before it scrolls out.
    var needed = Math.ceil((barWidth * 2) / (groupWidth + gap));
    needed = Math.max(2, Math.min(needed, MAX_COPIES));

    for (var i = 1; i < needed; i++) {
      var clone = group.cloneNode(true);
      clone.classList.add('marquee__group--clone');
      clone.setAttribute('aria-hidden', 'true');

      // Clones must be invisible to both screen readers and the theme
      // editor, otherwise clicking a block selects a copy of it.
      clone.querySelectorAll('[data-shopify-editor-block]').forEach(function (el) {
        el.removeAttribute('data-shopify-editor-block');
      });
      clone.querySelectorAll('a').forEach(function (el) {
        el.setAttribute('tabindex', '-1');
      });

      track.appendChild(clone);
    }

    // Duration covers one group plus one gap, keeping speed constant in
    // pixels per second no matter how many items the merchant adds.
    var distance = groupWidth + gap;
    bar.style.setProperty('--marquee-shift', distance.toFixed(2) + 'px');
    bar.style.setProperty('--marquee-duration', (distance / speed).toFixed(2) + 's');

    // Restart from zero so the new distance doesn't take effect mid-cycle,
    // which would show as a jump.
    track.style.animation = 'none';
    void track.offsetWidth;
    track.style.animation = '';
  }

  function initAll() {
    document.querySelectorAll('.marquee').forEach(function (bar) {
      layout(bar);

      if (window.ResizeObserver && !bar.dataset.marqueeObserved) {
        bar.dataset.marqueeObserved = '1';
        var pending;
        new ResizeObserver(function () {
          clearTimeout(pending);
          pending = setTimeout(function () { layout(bar); }, 150);
        }).observe(bar);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', initAll);

  // Fonts change text width after they swap in, which shifts the loop point.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(initAll);
  }

  initAll();
})();

  } catch(e) { console.error(e); }
})();
})();
